module.exports = __webpack_public_path__ + "img/ic_autorenew.e2689283.svg";